import { render, staticRenderFns } from "./GuideMainPage.vue?vue&type=template&id=f9489e72&scoped=true&lang=pug&"
import script from "./GuideMainPage.vue?vue&type=script&lang=ts&"
export * from "./GuideMainPage.vue?vue&type=script&lang=ts&"
import style0 from "./GuideMainPage.vue?vue&type=style&index=0&id=f9489e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9489e72",
  null
  
)

export default component.exports